// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3lKsv","label":"Completed_label__2I-zG"};